import browser from './browser';
import UI from './ui';
import digit from './digit';

export default {
  browser,
  digit,
  UI,
}